import {
  useDeleteCRFEventMutation,
  useLazyGetPatientsDetailsQuery,
  useLazyGetVisitsCRFOIDsQuery,
  useStartVisitMutation,
  useStartVisitStatusMutation,
  useLazyGetVisitSpecificCRFOIDsQuery,
  useLazyGetAllPatientVisitsQuery
} from 'src/services/trailNotebookCRF';

export const useTrailNotebookCRF = () => {
  const [
    getVisitsAndCRFOIDs,
    {
      data: getVisitsAndCRFOIDsData,
      isError: getVisitsAndCRFOIDsIsError,
      isSuccess: getVisitsAndCRFOIDsIsSuccess,
      isLoading: getVisitsAndCRFOIDsIsLoading,
      error: getVisitsAndCRFOIDsError
    }
  ] = useLazyGetVisitsCRFOIDsQuery();

  const [
    getPatientsDetails,
    {
      data: getPatientsDetailsData,
      isError: getPatientsDetailsIsError,
      isSuccess: getPatientsDetailsIsSuccess,
      isLoading: getPatientsDetailsIsLoading,
      error: getPatientsDetailsError
    }
  ] = useLazyGetPatientsDetailsQuery();

  const [
    deleteCRFEvent,
    {
      data: deleteCRFEventData,
      isError: deleteCRFEventIsError,
      isSuccess: deleteCRFEventIsSuccess,
      isLoading: deleteCRFEventIsLoading,
      error: deleteCRFEventError
    }
  ] = useDeleteCRFEventMutation();

  /** CTMSKANBAN-5655-5598 Start */
  const [
    getAllPatientVisits,
    {
      data: getAllPatientVisitsData,
      isError: getAllPatientVisitsIsError,
      isSuccess: getAllPatientVisitsIsSuccess,
      isLoading: getAllPatientVisitsIsLoading,
      error: getAllPatientVisitsError
    }
  ] = useLazyGetAllPatientVisitsQuery();
  const [
    startPatientVisit,
    {
      data: startPatientVisitData,
      isError: startPatientVisitIsError,
      isSuccess: startPatientVisitIsSuccess,
      isLoading: startPatientVisitIsLoading,
      error: startPatientVisitError
    }
  ] = useStartVisitMutation();

  const [
    getVisitSpecificCRFs,
    {
      data: getVisitSpecificCRFsData,
      isError: getVisitSpecificCRFsIsError,
      isSuccess: getVisitSpecificCRFsIsSuccess,
      isLoading: getVisitSpecificCRFsIsLoading,
      error: getVisitSpecificCRFsError
    }
  ] = useLazyGetVisitSpecificCRFOIDsQuery();
  const [
    getStartPatientVisitStatus,
    {
      data: getStartPatientVisitStatusData,
      isError: getStartPatientVisitStatusIsError,
      isSuccess: getStartPatientVisitStatusIsSuccess,
      isLoading: getStartPatientVisitStatusIsLoading,
      error: getStartPatientVisitStatusError
    }
  ] = useStartVisitStatusMutation();
  /** CTMSKANBAN-5655-5598 End */

  return {
    getVisitsAndCRFOIDs,
    getVisitsAndCRFOIDsData,
    getVisitsAndCRFOIDsIsError,
    getVisitsAndCRFOIDsIsSuccess,
    getVisitsAndCRFOIDsIsLoading,
    getVisitsAndCRFOIDsError,
    getPatientsDetails,
    getPatientsDetailsData,
    getPatientsDetailsIsError,
    getPatientsDetailsIsSuccess,
    getPatientsDetailsIsLoading,
    getPatientsDetailsError,
    deleteCRFEvent,
    deleteCRFEventData,
    deleteCRFEventIsError,
    deleteCRFEventIsSuccess,
    deleteCRFEventIsLoading,
    deleteCRFEventError,
    /** CTMSKANBAN-5655-5598 Start */
    getAllPatientVisits,
    getAllPatientVisitsData,
    getAllPatientVisitsIsError,
    getAllPatientVisitsIsSuccess,
    getAllPatientVisitsIsLoading,
    getAllPatientVisitsError,
    startPatientVisit,
    startPatientVisitData,
    startPatientVisitIsError,
    startPatientVisitIsSuccess,
    startPatientVisitIsLoading,
    startPatientVisitError,
    getStartPatientVisitStatus,
    getStartPatientVisitStatusData,
    getStartPatientVisitStatusIsError,
    getStartPatientVisitStatusIsSuccess,
    getStartPatientVisitStatusIsLoading,
    getStartPatientVisitStatusError,
    getVisitSpecificCRFs,
    getVisitSpecificCRFsData,
    getVisitSpecificCRFsIsError,
    getVisitSpecificCRFsIsSuccess,
    getVisitSpecificCRFsIsLoading,
    getVisitSpecificCRFsError
    /** CTMSKANBAN-5655-5598 End */
  };
};
